import React, { Component } from 'react';
import 'styles/core.scss';

export default class Layout extends Component {
  static propTypes = {
    children: React.PropTypes.element
  }

  constructor () {
    super();
  }

  render () {
    return (
      <div className="page-container">
        <div className="view-container">
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/layout.jsx